const StrateMaillageBlogGuideCards = {
    
    init() {
        const strates = document.querySelectorAll('.strate-maillage-blog-guide-cards');

        const leftBtn = $('.strate-maillage-blog-guide-cards .link_nav.left');
        const rightBtn = $('.strate-maillage-blog-guide-cards .link_nav.right');
        
        if (strates.length > 0) {
            $('.strate-maillage-blog-guide-cards .js-slider_blog_guide').addClass('owl-carousel');
            $('.strate-maillage-blog-guide-cards .js-slider_blog_guide').owlCarousel(
                {
                    items: 1,
                    nav: false,
                    dots: true,
                    stagePadding: 0,
                    autoWidth: true,
                    loop: true,
                    margin: 40,
                }
            );

            leftBtn.click(
                function () {
                    const this_slider = $(this).parent().attr('data-slider');
                    $('.' + this_slider + ' .owl-prev').trigger('click');
                    return false;
                }
            );
            rightBtn.click(
                function () {
                    const this_slider = $(this).parent().attr('data-slider');
                    $('.' + this_slider + ' .owl-next').trigger('click');
                    return false;
                }
            );
        }
    },
};

export default StrateMaillageBlogGuideCards;
